export function normalized(str) {
    if (str === null || str === undefined) return str;

    return str.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase();
}


// WEBPACK FOOTER //
// ./src/utils/string.js